import { innerHtmlJSX } from '@util';

import styled, { css } from 'vue-styled-components';

import { GRAY, RED, GRAY_COLOR, FONT_SIZE } from '@styles/common.styled';

import { FLEX_COLUMN_DIV, make } from '@styles/common.styled.component';

export default {
    name: 'DeleteDialog',
    props: {
        value: String,
        message: String,
    },
    functional: true,
    render(h, { props }) {
        return (
            <FLEX_COLUMN_DIV>
                <DeleteMessage {...innerHtmlJSX(props.message)} />
                {props.value !== undefined && (
                    <DeleteInputWrapper>
                        <input value={props.value} disabled={true} />
                    </DeleteInputWrapper>
                )}
            </FLEX_COLUMN_DIV>
        );
    },
};

const DeleteMessage = make({
    base: FLEX_COLUMN_DIV,
    styles: [
        GRAY_COLOR[100],
        FONT_SIZE[16],
        css`
            span {
                color: ${RED(60)};
            }
        `,
    ],
});

const DeleteInputWrapper = styled(FLEX_COLUMN_DIV)`
    margin-top: 20px;
    border-radius: 2px;
    border: solid 1px ${GRAY(25)};
    background-color: white;
    height: 44px;

    input {
        border: none;
        height: 100%;
        padding: 12px;
        font-size: 14px;
        font-weight: 500;
        color: ${GRAY(60)};

        &:focus,
        &:active {
            border: none;
            outline: none;
        }
    }
`;
